import { Button } from 'antd';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useForm } from 'react-hook-form';

const ResetPasswordForEmail = ({ onSubmit, loading }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({});

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <label>
            Email <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            {...register('email', { required: true })}
          />
          <small style={{ color: 'red', height: '32px' }}>
            <p>{errors.email ? 'Please enter the email' : ''}</p>
          </small>
        </div>
        <div className="form-group login-btn">
          <Button
            key="ok"
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            size="large"
          >
            Reset Password
          </Button>
        </div>
      </form>
    </>
  );
};

ResetPasswordForEmail.propTypes = {
  loading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ResetPasswordForEmail;
